import { TheTabs } from '../_components/'

export default [
  {
    path: 'fingerbank/general_settings',
    name: 'fingerbankGeneralSettings',
    component: TheTabs,
    props: () => ({ tab: 'general_settings' })
  }
]
